import { gql } from '@apollo/client'

export default gql`
  mutation SaveInviteSetting(
    $starID: String!
    $settings: [OrbitalTrackInviteSettingUpdateInput!]
  ) {
    saveInviteSetting(starID: $starID, settings: $settings)
  }
`
